<template>
  <div class="bg-white rounded">
    <div class="d-flex align-items-center mb-2">
      <i class="fas fa-clock mr-2 text-orange"></i>
      <div class="color-gray-7 font-16 font-weight-bold">
        Historial de Citas
      </div>
    </div>
    <time-line class="mt-4 col-12 mx-auto px-0">
      <time-line-item
        v-for="(item, index) in itemsFiltered"
        :key="index"
        class="custom-time-line rounded"
      >
        <div class="row">
          <div class="col-12 col-md-2 flex-column d-flex">
            <label class="mb-0 color-gray-6 text-small">
              Fecha de Cita:
            </label>
            <span class="text font-weight-bold">
              {{ formatDate(item.date) }}
            </span>
          </div>
          <div class="mt-2 mt-md-0 col-12 col-md-2 flex-column d-flex">
            <label class="mb-0 color-gray-6 text-small">
              Hora Desde:
            </label>
            <span class="text font-weight-bold">
              {{ getTimeFromDate(item.start) }}
            </span>
          </div>
          <div class="mt-2 mt-md-0 col-12 col-md-2 flex-column d-flex">
            <label class="mb-0 color-gray-6 text-small">
              Hora Hasta:
            </label>
            <span class="text font-weight-bold">
              {{ getTimeFromDate(item.end) }}
            </span>
          </div>
          <div class="mt-2 mt-md-0 col-12 col-md-3 flex-column d-flex">
            <label class="mb-0 color-gray-6 text-small">
              CAAT:
            </label>
            <span class="text font-weight-bold"></span>
            {{ getCaats(item) | empty }}
          </div>
          <div class="mt-2 mt-md-0 col-12 col-md-3 flex-column d-flex">
            <label class="mb-0 color-gray-6 text-small">Estatus:</label>
            <span class="d-flex align-items-center">
              <div
                class="status-indicator"
                :style="{ backgroundColor: item.color }"
              >
                &nbsp;
              </div>
              <span class="text font-weight-bold">{{ item.status }}</span>
            </span>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-12 col-md-4 flex-column d-flex">
            <label class="mb-0 color-gray-6 text-small">
              Nombre de Participantes:
            </label>
            <span class="text font-weight-bold">
              {{ getParticipant(item) }}
            </span>
          </div>
          <div class="mt-2 mt-md-0 col-12 col-md-4 flex-column d-flex">
            <label class="mb-0 color-gray-6 text-small">
              Compañia:
            </label>
            <span class="text font-weight-bold">
              {{ getCompany(item) | empty }}
            </span>
          </div>
          <div
            v-if="item.activityType"
            class="mt-2 mt-md-0 col-12 col-md-4 flex-column d-flex"
          >
            <label class="mb-0 color-gray-6 text-small">
              Actividad:
            </label>
            <span class="text font-weight-bold">
              {{ item.activityType | empty }}
            </span>
          </div>
        </div>
        <div class="row mt-4">
          <div class="mt-2 mt-md-0 col-12 col-md-4 flex-column d-flex">
            <label class="mb-0 color-gray-6 text-small">
              Usuario:
            </label>
            <span class="text font-weight-bold">
              {{ item.username }}
            </span>
          </div>
        </div>
        <div class="row mt-4 " v-if="item.statusReason">
          <div class="col-12 flex-column d-flex">
            <label class="mb-0 color-gray-6 text-small">
              Razón:
            </label>
            <span class="text font-weight-bold">
              {{ item.statusReason }}
            </span>
          </div>
        </div>
        <template #icon>
          <em :class="`fal fa-retweet text-white`" class="radius" />
        </template>
        <template #date>
          <div class="date-container">
            <div class="color-black font-16 font-weight-bold fulldate">
              {{ formatDate(item.createDate) }}
            </div>
            <div class="color-black font-12 fulldate">
              {{ getTimeFromDate(item.createDate) }}
            </div>
          </div>
        </template>
      </time-line-item>
    </time-line>
    <custom-result-not-found
      v-if="this.items.length == 0"
      class="mt-4 row pt-3"
      text="No hay Información Disponible."
    />
    <div v-if="this.currentRowCount < this.items.length" class="row">
      <div class="col text-center">
        <action-button
          variant="outline-success custom-view-more actionButton"
          i="fas fa-chevron-down"
          @click="loadMore"
        >
          {{ viewMoreLabels }}
        </action-button>
      </div>
    </div>
    <div class="d-flex justify-content-end" v-if="hasCloseButton">
      <action-button
        type="button"
        text="Cerrar"
        i="fa fa-times-circle"
        variant="outline-success"
        class="ml-2 px-4 mb-3 actionButton"
        @click="close()"
      />
    </div>
  </div>
</template>

<script>
import { TimeLine, TimeLineItem } from '@quisit/mipe-timeline';
import ActionButton from 'ActionButton';
import moment from 'moment';
import CustomResultNotFound from 'custom-result-not-found';

export default {
  name: 'AppointmentTimeline',
  components: {
    TimeLine,
    TimeLineItem,
    ActionButton,
    CustomResultNotFound,
  },
  props: {
    items: { type: Array, default: () => [] },
    viewMoreLabels: { type: String, default: 'Ver Más' },
    hasCloseButton: { type: Boolean, default: false },
  },
  data: () => ({
    maxRows: 5,
    itemsFiltered: [],
    currentRowCount: 0,
  }),
  computed: {
    getParticipant() {
      return (item) =>
        item.participants.length > 0
          ? item.participants.map((a) => a.fullName).join(', ')
          : '-';
    },
    getCompany() {
      return (item) =>
        item.participants.length > 0
          ? item.participants.map((a) => a.companyName).join(', ')
          : '-';
    },
    getCaats() {
      return (item) =>
        item.participants.length > 0
          ? item.participants.map((a) => a.caats).join(', ')
          : '-';
    },
  },
  watch: {
    items(newValue) {
      this.loadMore();
    },
  },
  mounted() {},
  methods: {
    loadMore() {
      this.currentRowCount += this.maxRows;
      this.itemsFiltered = this.items.slice(0, this.currentRowCount);
    },
    formatDate(date) {
      return moment(date)
        .locale('es')
        .format('DD/MMM/YYYY');
    },
    getTimeFromDate(value) {
      return moment(value).format('h:mm A');
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables/_colors.scss';
.title {
  font-size: 16px;
  font-weight: bold;
  color: map-get($colors, 'gray-12');
}
.event-date {
  font-weight: bold;
  font-size: 15px;
  color: #11291b;
  opacity: 1;
}
.status-indicator {
  width: 12px;
  height: 12px;
  float: left;
  border-radius: 50%;
  margin-right: 5px;
}
.text {
  font-size: 16px;
  color: $black_2;
}
.text-small {
  font-size: 14px;
}

.actionButton {
  border-radius: 19px;
}

.radius {
  padding: 7px 0 0 0 !important;
  width: 30px !important;
  height: 30px !important;
}
</style>
